import React, { useState } from 'react';
import { SignOut } from '../../../auth/sign-out/ui/SignOut';
import styled from '@emotion/styled';
import { StyledShortcut } from '../../../home/ui/shortcuts/StyledShortcut';
import { Section } from '../../../content-sections/ui/components/Section';
import ContentWrap from '../../../../ui/components/Layout/ContentWrap';
import Responsive from '../../../../ui/utils/Responsive';
import { Css } from '../../../../ui';
import { signOut } from '../../../auth/sign-out/domain/use-cases/signOut';
import { useNavigate } from '../../../shared/router/useNavigate';

interface ISignOutShortcutProps {
	redirectUrl?: string;
}

export const SignOutShortcut = ({ redirectUrl }: ISignOutShortcutProps) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const redirect = async () => {
		if (!redirectUrl) return;

		await navigate(redirectUrl);
	};

	const onClick = () => {
		if (loading) return;

		setLoading(true);
		signOut({ redirect });
	};

	return (
		<Section>
			<ContentWrap>
				<StyledSignOutShortcut onClick={onClick}>
					<SignOut variant="error" disabled={loading} />
				</StyledSignOutShortcut>
			</ContentWrap>
		</Section>
	);
};

const StyledSignOutShortcut = styled(StyledShortcut.withComponent('div'))`
	width: ${Css.pxToRem(282)};
	height: ${Css.pxToRem(88)};
	gap: 10px;
	color: initial;

	display: flex;
	align-items: center;
	justify-content: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		width: auto;
	}
`;
